// 빌드 식별(D5b): vite.config.ts define이 넣는 버전·빌드 SHA. 테스트·Worker(정의 없음)에서는 'dev'
declare const __DH_VERSION__: string | undefined;
declare const __DH_BUILD__: string | undefined;
export const APP_VERSION: string = typeof __DH_VERSION__ === 'string' ? __DH_VERSION__ : 'dev';
export const APP_BUILD: string = typeof __DH_BUILD__ === 'string' ? __DH_BUILD__ : 'dev';
